export const JOBS_REPORT_COMBOS_IDS = [
  'batch_list',
]
